export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = String(m).padStart(2, '0');
  const ss = String(sec).padStart(2, '0');
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function formatDuration(seconds?: number): string {
  if (!seconds) return '—';
  const s = Math.round(seconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h ? `${h}h ${m}m` : m ? `${m}m ${s % 60}s` : `${s}s`;
}

export function formatWhen(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export const STATUS_LABELS: Record<string, string> = {
  generating: 'Generating',
  draft: 'Draft',
  in_review: 'In review',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  published: 'Published',
  archived: 'Archived',
};

export const STATUS_STYLES: Record<string, string> = {
  generating: 'bg-indigo-50 text-indigo-700',
  draft: 'bg-gray-100 text-gray-700',
  in_review: 'bg-amber-50 text-amber-700',
  changes_requested: 'bg-red-50 text-red-700',
  approved: 'bg-emerald-50 text-emerald-700',
  published: 'bg-emerald-100 text-emerald-800',
  archived: 'bg-gray-100 text-gray-500',
};

const RUN_FAILED_STYLE = 'bg-red-50 text-red-700';

/** Label and colour for a SOP row/page. A draft whose last generation failed says so, so it can be retried. */
export function displayStatus(
  status: string,
  run?: { status: string; progress?: number },
): { label: string; style: string } {
  if (status === 'generating') {
    const pct = run?.progress ? ` ${Math.min(99, run.progress)}%` : '';
    return { label: `Generating${pct}`, style: STATUS_STYLES.generating };
  }
  if (status === 'draft' && run?.status === 'failed') return { label: 'Generation failed', style: RUN_FAILED_STYLE };
  return { label: STATUS_LABELS[status] ?? status, style: STATUS_STYLES[status] ?? STATUS_STYLES.draft };
}
